/**
 * PatternSpotlight — json-render adapter wrapping real PatternSpotlightCard
 *
 * Transforms semantic catalog props into PatternSpotlightCard props.
 * Catalog (LLM-friendly) -> Registry (adapter) -> Real RN Component
 *
 * Prop mapping:
 *   patternName  -> patternType
 *   description  -> description
 *   occurrences  -> frequency
 *   examples     -> context (joined as quoted lines)
 *   suggestion   -> (appended to context)
 *   severity     -> (used for data-attribute only; real component uses tier styling)
 *   tierLevel    -> forced to 2 (tier enforcement is upstream via injectTierGuards)
 *
 * [DRAMA+ ONLY] — tier enforcement handled by injectTierGuards() upstream.
 *
 * Task: [#1158.SDUI-M.P3.4a]
 * Agent: Diego <diego@liftping.net>
 */
"use client";

import React from "react";
import { PatternSpotlightCard } from "../../components/PatternSpotlightCard";
import type { PatternSpotlightProps } from "../schema";

export function PatternSpotlight({
  patternName,
  description,
  severity: _severity,
  occurrences,
  examples,
  suggestion,
}: PatternSpotlightProps) {
  // Build context string from examples and suggestion
  const contextParts: string[] = [];
  if (examples && examples.length > 0) {
    contextParts.push(examples.map((ex) => `"${ex}"`).join(" "));
  }
  if (suggestion) {
    contextParts.push(`Reframe: ${suggestion}`);
  }
  const context = contextParts.length > 0 ? contextParts.join(" — ") : undefined;

  return (
    <PatternSpotlightCard
      patternType={patternName}
      description={description}
      frequency={occurrences}
      context={context}
      tierLevel={2}
    />
  );
}
